// Core
import React, {
  useRef,
  useState,
} from 'react';

// Components
import {
  Button,
  ButtonSize,
  ButtonType,
} from '../Button';
import {
  OptionsSelect,
  OptionsSelectMode,
  OptionsSelectPosition,
} from '../OptionsSelect';
import { LayoutColumn } from '../../icons';

// Hooks
import { useOnClickOutside } from '../../../hooks/useOnClickOutside';

// Component
import { TableColumnLayoutProps } from './TableColumnLayout.types';
import { Container, Element } from './TableColumnLayout.style';

function TableColumnLayout({
  className,
  onSelect,
  options,
  position = OptionsSelectPosition.bottomLeft,
  selected,
  testId,
}: TableColumnLayoutProps): JSX.Element {
  // Ref
  const dropdownRef = useRef(null);

  /* **********************************************************************************************
  ***************************************** LOCAL STATES ******************************************
  ********************************************************************************************** */

  const [isOpen, setIsOpen] = useState<boolean>(false);

  /* **********************************************************************************************
  ******************************************* METHODS *********************************************
  ********************************************************************************************** */

  // Hook to handle clicks outside the dropdown
  useOnClickOutside(dropdownRef, () => {
    setIsOpen(false);
  });

  return (
    <Container
      ref={dropdownRef}
      data-testid={testId}
      className={className}
    >
      <Element>
        <Button
          block
          onClick={() => setIsOpen((prevState) => !prevState)}
          size={ButtonSize.xs}
          square
          type={ButtonType.secondary}
        >
          <LayoutColumn />
        </Button>
        <OptionsSelect
          mode={OptionsSelectMode.multiple}
          onClose={() => setIsOpen(isOpen)}
          onSelect={onSelect}
          open={isOpen}
          options={options}
          position={position}
          selected={selected}
          testId="options-select-container"
        />
      </Element>
    </Container>
  );
}

export { TableColumnLayout };
